export type GuidedItineraryDraftDayInput = {
  day?: number;
  title?: string;
  description?: string | string[];
};

export type GuidedItineraryDay = {
  day: number;
  title: string;
  points: string[];
  description?: string;
};

export const normalizeItineraryDescriptionPoints = (description: string | string[] | null | undefined): string[] => {
  if (Array.isArray(description)) {
    return description.map((point) => String(point).trim()).filter(Boolean);
  }

  if (typeof description === 'string') {
    return description
      .split(/\n+/)
      .map((point) => point.trim())
      .filter(Boolean);
  }

  return [];
};

export const normalizeItineraryDraftDay = (
  day: GuidedItineraryDraftDayInput,
  index: number
): GuidedItineraryDay => {
  const points = normalizeItineraryDescriptionPoints(day.description);

  return {
    day: Number(day.day || index + 1),
    title: String(day.title || '').trim(),
    description: points.join('\n'),
    points,
  };
};
